import { isEqual } from "lodash";

// this is almost certainly going to grow complexity around matching path prefixes, if nothing else
function errorMatchesPath(error, pathToMatch) {
  return isEqual(error.path, pathToMatch);
}

export default errorMatchesPath;
